import { SVGProps } from "react";

const IconShop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99997 8.11738C6.99997 8.66956 6.5561 9.11719 5.99997 9.11719C5.44768 9.11719 4.99997 8.67347 4.99997 8.11738L3.99997 8.11719V16.1172H7.99997L7.99997 16.1143V11.1201C7.99997 10.5662 8.44332 10.1172 8.99902 10.1172H11.0009C11.5527 10.1172 12 10.5657 12 11.1201V16.1143L12 16.1172H16V8.11719H15C15 8.66956 14.5561 9.11719 14 9.11719C13.4477 9.11719 13 8.67347 13 8.11738L11 8.11719C11 8.66956 10.5561 9.11719 9.99997 9.11719C9.44768 9.11719 8.99997 8.67347 8.99997 8.11738L6.99997 8.11719V8.11738ZM6.99997 6.11719H8.99997V5.11699C8.99997 4.56482 9.44383 4.11719 9.99997 4.11719C10.5523 4.11719 11 4.5609 11 5.11699V6.11719H13V5.11699C13 4.56482 13.4438 4.11719 14 4.11719C14.5523 4.11719 15 4.5609 15 5.11699V6.11719H16.2759C17.1288 6.11719 17.4083 5.73284 17.146 4.91603L16.2467 2.11719H3.7244L2.85423 4.91603C2.59225 5.73198 2.8726 6.11719 3.7244 6.11719H4.99997V5.11699C4.99997 4.56482 5.44383 4.11719 5.99997 4.11719C6.55225 4.11719 6.99997 4.5609 6.99997 5.11699V6.11719ZM18 7.67855V17.1147C18 17.6684 17.5553 18.1172 16.9991 18.1172H3.00085C2.44808 18.1172 1.99997 17.6687 1.99997 17.1147V7.67779C0.936608 7.03876 0.480059 5.76822 0.949976 4.30463L1.9897 1.06631C2.15801 0.542123 2.73905 0.117188 3.29375 0.117188H16.7065C17.2584 0.117188 17.8439 0.547302 18.0106 1.06631L19.0503 4.30463C19.5203 5.7685 19.0644 7.03967 18 7.67855Z"
      fill="#303D49"
    />
  </svg>
);

export default IconShop;
